// extracted by mini-css-extract-plugin
export default {"text":"Header_text__kiOfT"};